export default class EmptyImageUtils {
    private static readonly DEFAULT_PLACEHOLDER_PATH = '/images/placeholder-no-image-1.svg';

    public static getPlaceholderImage(): string {
        return this.DEFAULT_PLACEHOLDER_PATH;
    }

    public static getPlaceholderImageAlt(): string {
        return 'No image available';
    }
} 